var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.innerVisible,
        width: _vm.dialogWidth,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.closeHandler
      }
    },
    [
      _vm.elementformulaEditable
        ? _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Account" } },
                [
                  _c(
                    "el-select",
                    {
                      ref: "accountTitleRef",
                      staticStyle: { width: "300px" },
                      attrs: {
                        filterable: true,
                        clearable: true,
                        placeholder: "Please select"
                      },
                      model: {
                        value: _vm.form.accountTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "accountTitle", $$v)
                        },
                        expression: "form.accountTitle"
                      }
                    },
                    _vm._l(_vm.newAccountCollection, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.accountTitleLabelFun(item),
                          value: item.accountTitle
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addAccountTitleBtnClickHandler }
                    },
                    [_vm._v("Add")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          _c("cargo-ag-grid", {
            staticStyle: {
              width: "100%",
              height: "300px",
              "padding-left": "2px"
            },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            }
          }),
          _c("cargo-ag-grid", {
            staticClass:
              "accounting-document-grid accounting-document-grid-footer",
            staticStyle: { width: "100%", "padding-left": "2px" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.footer.gridOptions,
              "column-defs": _vm.columnDefs2,
              "row-data": _vm.footer.rowData,
              "auto-fit-content": false
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "padding-right": "300px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.elementformulaEditable
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveHander } },
                [_vm._v("Confirm")]
              )
            : _vm._e(),
          _c("el-button", { on: { click: _vm.closeHandler } }, [
            _vm._v("Cancel")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }